import React, { useState } from "react";
import { FaMoon, FaLanguage, FaBell, FaRegDotCircle } from "react-icons/fa";
import Avator from "../resources/images/233080884_1289771474826255_357433678636159821_n.jpg";
import { Link } from "react-router-dom";
import "./Menubar.css";
// import Liveeditng from "./Liveeditng/Liveeditng";

const Menubar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [unreadNotifications, setUnreadNotifications] = useState(0);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch(searchTerm);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuClick = (option) => {
    console.log("Clicked:", option);
  };

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    document.documentElement.setAttribute(
      "data-theme",
      isDarkMode ? "light" : "dark",
    );
  };

  const handleChangeLanguage = (language) => {
    setSelectedLanguage(language);
    console.log("Selected language:", language);
  };

  const handleNotificationClick = () => {
    setUnreadNotifications(0);
  };

  // live editing
  const [isliveOpen, setIsliveOpen] = useState(false);

  const toggleSection = () => {
    setIsliveOpen(!isliveOpen);
  };

  // const handleLogout = () => {
  //   localStorage.removeItem("token"); // or sessionStorage.clear();
  //   window.location.href = "/login"; // redirect to login page
  // };
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("authToken");
    localStorage.removeItem("rememberPassword");
    localStorage.removeItem("token");
    // localStorage.removeItem("user");

    // Clear user data from localStorage

    localStorage.removeItem("jwtToken");
    localStorage.removeItem("username");
    localStorage.removeItem("user");
    // setUsername(null);
    // setUser(null);

    // Reset user data in state

    // if rememberMe is not checked
    // if (!rememberMe) {
    //   localStorage.removeItem("rememberEmail");
    // }
    // handleClose();
    // window.location.reload(); // Refresh to reflect logout
    // navigate("/home"); // Redirect to the sign-in page
    window.location.href = "/login";
  };

  return (
    <div>
      <div className="dashboard_menubar_upper_container">
        <div className="menu_search_container">
          <form onSubmit={handleSubmit} className="search-form">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleChange}
              className="search-input"
            />
            <button type="submit" className="search-button">
              Search
            </button>
          </form>
        </div>
        <div className="live_editing">
          <button onClick={toggleSection}>
            <FaRegDotCircle /> Live Editing
          </button>

          {isliveOpen && (
            <div className="toggleSection_live_editing">
              <div className="live_editing_users_menu">
                <Link to="/liveeditingusers">Users</Link>
              </div>
              <div className="live_editing_products_menu">
                <Link to="/liveeditng">Products</Link>
              </div>
            </div>
          )}
        </div>
        <div className="language-selector">
          <FaLanguage className="language-icon" />
          <select
            value={selectedLanguage}
            onChange={(e) => handleChangeLanguage(e.target.value)}
          >
            <option value="en">English</option>
            <option value="am">Amharic</option>
            <option value="it">Italian</option>
          </select>
        </div>
        <div className="notification-icon" onClick={handleNotificationClick}>
          <FaBell />
          {unreadNotifications > 0 && (
            <span className="notification-count">{unreadNotifications}</span>
          )}
        </div>
        <div className="theme-changer" onClick={toggleTheme}>
          <FaMoon className={`theme-icon ${isDarkMode ? "dark" : "light"}`} />
        </div>
        <div className="profile-icon-container">
          <div className="profile-icon" onClick={toggleMenu}>
            <img src={Avator} alt="Profile" className="avatar" />
          </div>
          {isOpen && (
            <div className="dropdown-menu">
              <div
                className="menu-item"
                onClick={() => handleMenuClick("My Profile")}
              >
                My Profile
              </div>
              <div
                className="menu-item"
                onClick={() => handleMenuClick("Settings")}
              >
                Settings
              </div>
              <div
                className="menu-item"
                // onClick={() => handleMenuClick("Exit")}
                onClick={handleLogout}
              >
                Exit
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Menubar;
